<template>
  <div>
    <Header class="head" :height="40" title="融资融券"/>
    <div class="main">
      <div class="chart">
        <div class="balance-title">两融余额图</div>
        <div class="tabs">
          <div class="tab" v-for="(v,k) in tabs" :key=k @click="curTab=v.value" :class="{'curTab': v.value === curTab, 'curTab-left': v.value === curTab && k===0, 'curTab-right': v.value === curTab && k===2}">
            {{v.label}}
          </div>
        </div>
        <RzrqChart :tab=curTab />
      </div>
      <div class="date">
        <div class="chose-date">选择日期</div>
        <div class="date-icons" @click="calendarShow=true">
          <img src="@/assets/date.png" class="dateIcon">
          <div class="date-text">{{date}}</div>
          <div class="dsj"></div>
        </div>
      </div>
      <boxHead class="margin6" title="两市融资融券交易总量">
        <RzrqTotal :tab=curTab :date=date />
      </boxHead>
      <boxHead class="margin6" title="融资净买卖前五">
        <RzrqTopFive :tab=curTab :date=date />
      </boxHead>
      <boxHead title="个股两融买卖明细">
        <RzrqDetail :tab=curTab :date=date />
      </boxHead>
    </div>
    <Calendar
      :show.sync="calendarShow"
      :defaultDate="date"
      :enableDate="enableDates"
      :minDate="new Date() - 365 * 24 * 3600000"
      :maxDate="new Date() - 0"
      @change="handelChange" />
  </div>
</template>
<script>
import Header from '@/components/header.vue'
import RzrqChart from './rzrqChart.vue'
import RzrqTotal from './rzrqTotal.vue'
import RzrqTopFive from './rzrqTopFive.vue'
import RzrqDetail from './rzrqDetail.vue'
import boxHead from './boxHead.vue'
import Calendar from '@/utils/calendar/calendar.vue'
import {getDateStringForLong} from '@/utils/formatUnit'
import {request} from '@/api/request';

export default {
  data() {
    return {
      curTab: 'both',
      date: '',
      //showDate: '',
      calendarShow: false,
      enableDates: [],
      tabs: [
        {label: '两市', value: 'both'}, {label: '沪市', value: 'sh'}, {label: '深市', value: 'sz'}
      ]
    }
  },
  async created() {
    this.enableDates = (await this.getTradingDays(365)).map(v => v * 1000);
    const today = new Date(new Date().toLocaleDateString()).getTime()
    if (!~this.enableDates.indexOf(today)) {
      this.date = getDateStringForLong(this.enableDates[0]);
    }else{
      this.date = getDateStringForLong(this.enableDates[1]);
    }
    //this.showDate = this.date
  },
  components: {
    Header, boxHead, RzrqChart, RzrqTotal, RzrqTopFive, RzrqDetail, Calendar
  },
  methods: {
    handelChange(date){
      const newDate = getDateStringForLong(date);
      this.date = newDate
    },
    async getTradingDays(limit = 3, market = 'sh') {
      return await request.get({
          url: request.apis.quote.tradingdays,
          params: {
              market,
              limit
          }
      })
    },
    async getLatestTradingDay() {
      const res = await request.get({
          url: request.apis.rank.summary,
          params: {
              tradingDay: this.date
          }
      })
      if(res && res.tradingDay) {
        return res.tradingDay
      }
      return getDateStringForLong(Date.now())
    },
  },
}
</script>
<style lang="stylus" scoped>
.main
  height 100vh
  overflow auto
  -webkit-overflow-scrolling touch
  &::-webkit-scrollbar
    display none
.head
  font-weight 500
  /deep/ p 
    font-size .17rem
.chart
  margin-top 40px
  background #ffffff
.balance-title
  color #333333
  font-size .18rem
  font-weight 500
  line-height .25rem
  padding .12rem
.tabs
  width 2.4rem
  height .28rem
  border-radius .04rem
  border 1px solid #DCDDDC
  margin 0 auto
  display flex
  .tab
    flex 1
    line-height .28rem
    font-size .14rem
    color #666666
    text-align center
  .curTab
    background #F43737
    color #FFFFFF
  .curTab-left 
    border-radius .04rem 0px 0px .04rem
  .curTab-right 
    border-radius 0px .04rem .04rem 0px
.date
  margin-top .06rem
  background #ffffff
  height .36rem
  display flex
  justify-content space-between
  align-items center
  padding .08rem .12rem
  box-sizing border-box
  border-bottom 1px solid #EBEBEB

  .chose-date
    font-size .14rem
    color #333333
  .dateIcon
    width .16rem
    height .16rem
  .date-icons
    display flex
    align-items center
    .date-text
      margin  0 .08rem 0 .06rem
      font-size .14rem
      color #409AFB
      font-family PingFangSC-Regular,PingFang SC
    .dsj
      border .06rem solid transparent
      border-top .06rem solid #409AFB
      position relative
      top .03rem
.margin6
  margin-bottom .06rem
</style>